import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { getSessionMainId } from './utils/getCookie';
import { decryptToken } from './utils/getToken';

function isTokenValid(token) {
  if (!token) return false;
  try {
    const decoded = jwtDecode(token);
    if (decoded.exp && decoded.exp * 1000 < Date.now()) {
      return false;
    }
    return true;
  } catch {
    return false;
  }
}

function ProtectedRoute({ children }) {
  const sessionId = getSessionMainId();
  const token = decryptToken('accessToken');

  if (!sessionId || !isTokenValid(token)) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default ProtectedRoute;
